<div class="inicio">
  <p class="titulo">SOLICITUD DE SERVICIOS <!-- #161aff-->
    <mat-icon color="primary" matTooltip="Click para más información" (click)="botonInformacion()">info</mat-icon>
  </p>
  <div class="requerido"> <mat-label>* Campos requeridos </mat-label> </div>
  <form #insertForm="ngForm" [formGroup]="formSolicitud"> <!--(ngSubmit)="enviarSolicitud()"-->
    <div class="form-group">
    </div>
    <div class="grid-container">
      <div class="celda">
        <mat-label class="label">Tipo de solicitud a realizar<mat-label class="requerido">*</mat-label> </mat-label>
        <mat-form-field appearance="outline">
          <mat-select placeholder="Selecciona el tipo de solicitud" formControlName="tipoSolicitud" required
            (selectionChange)="limpiarCampos()">
            <mat-option *ngFor="let tipoSolicitud of listatipoSolicitudes" [value]=tipoSolicitud>{{
              tipoSolicitud.tipo_solicitud }}</mat-option>
          </mat-select>
          <mat-error *ngIf="this.formSolicitud.get('tipoSolicitud')?.errors?.['required']">
            El tipo de solicitud es requerido
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="div">

      <!--Nombre del colaborador-->
      <div class="grid-container">
        <div class="celda">
          <mat-label class="label">Nombre del solicitante<mat-label class="requerido">*</mat-label> </mat-label>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="solicitanteFilter  " #singleSelect4
              (selectionChange)="cargarDatosSolicitante($event)" required>
              <mat-option>
                <ngx-mat-select-search [formControl]="inputSolicitante" oninput="this.value = this.value.toUpperCase()">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  <span ngxMatSelectNoEntriesFound>
                    No se encontraron opciones
                  </span>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of listaFiltradaSol   | async" [value]="option">
                {{option.nomb_compl}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="this.solicitanteFilter.value=='' ">
              El nombre del colaborador es requerido
            </mat-error>
          </mat-form-field>
        </div>
        <div class="celda">
          <mat-label class="label">Nombre del colaborador<mat-label class="requerido">*</mat-label> </mat-label>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="colaboradorFilter" #singleSelect1
              (selectionChange)="llenarTablaActivados($event)" (selectionChange)="cargarDatosColaborador($event)"
              required>
              <mat-option>
                <ngx-mat-select-search [formControl]="inputColaboradorF"
                  oninput="this.value = this.value.toUpperCase()">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  <span ngxMatSelectNoEntriesFound>
                    No se encontraron opciones
                  </span>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of listaFiltradaEmp | async" [value]="option">
                {{option.nomb_compl}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="this.colaboradorFilter.value=='' ">
              El nombre del colaborador es requerido
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!--Cargo y sucursal/oficina-->
      <div class="grid-container2">
        <!--Cargo-->
        <div class="celda">
          <mat-label class="label"> Cargo </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Cargo del colaborador" formControlName="puesto" readonly />
          </mat-form-field>
        </div>

        <!--Oficina/Sucursal-->
        <div class="celda">
          <mat-label class="label"> Sucursal </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Sucursal u oficina del colaborador" formControlName="sucursal"
              readonly />
          </mat-form-field>
        </div>

      </div>
      <!--Reemplazo-->
      <div class="grid-container">
        <div class="celda" *ngIf="tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS'); ">
          <mat-label class="label"> ¿Cuenta con reemplazo? </mat-label>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Seleccione una opción" formControlName="reemplazo">
              <mat-option *ngFor="let reemplazo of listaReemplazo" [value]=reemplazo>{{ reemplazo }} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="grid-container">
        <!--Nombre a quien sustituye-->
        <div class="celda" *ngIf="tipoSoliSeleccionada('ALTA DE SERVICIOS');">
          <mat-label class="label">Sustituye a</mat-label>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="sustituyeFilter" #singleSelect2 (selectionChange)="cargarDatosSustituye($event)">
              <mat-option>
                <ngx-mat-select-search [formControl]="inputSustituyeF" oninput="this.value = this.value.toUpperCase()">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  <span ngxMatSelectNoEntriesFound>
                    No se encontraron opciones
                  </span>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of listaFiltradaSust | async" [value]="option">
                {{option.nomb_compl}}
              </mat-option>
            </mat-select>

          </mat-form-field>
        </div>

        <!--Nombre del supervisor-->
        <div class="celda" *ngIf="tipoSoliSeleccionada('ALTA DE SERVICIOS');">
          <mat-label class="label">Nombre del supervisor<mat-label class="requerido">*</mat-label> </mat-label>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="supervisorFilter" #singleSelect3
              (selectionChange)="cargarDatosSupervisor($event)" required>
              <mat-option>
                <ngx-mat-select-search [formControl]="inputSupervisorF" oninput="this.value = this.value.toUpperCase()">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  <span ngxMatSelectNoEntriesFound>
                    No se encontraron opciones
                  </span>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of listaFiltradaSup | async" [value]="option">
                {{option.nomb_compl}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="this.supervisorFilter.value=='' ">
              El nombre del supervisor es requerido
            </mat-error>
          </mat-form-field>
        </div>
      </div>


      <!--Servicio a solicitar-->
      <div class="grid-container">


        <div class="grid-container" class="label"
          *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS')==false && tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS')==false; ">
          <br>
          <div> <mat-label class="label"
              *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS')==false && tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS')==false; ">
              Servicios a solicitar <mat-label class="requerido">*</mat-label></mat-label>
          </div>
          <div>
            <mat-form-field appearance="fill">
              <mat-label> Seleccione los servicios que requiera</mat-label>
              <mat-select formControlName="tipo_servicio" multiple>
                <mat-option *ngFor="let servicio of listaServicios"
                  [value]="servicio">{{servicio.nombre_servicio}}</mat-option>
              </mat-select>
              <mat-error *ngIf="this.formSolicitud.value.tipo_servicio.length<=0 ">
                Es necesario que seleccione al menos un servicio
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!--TABLA SUSPENSION-->

        <div class="grid-container" *ngIf="tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS') ">
          <div class="grid-container2">
            <mat-form-field>
              <mat-label>BUSCAR</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="INGRESE DATO A BUSCAR">
            </mat-form-field>
          </div>

          <mat-label class="label"> Servicio que requiere suspención de privilegios: </mat-label>

          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="c1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
              <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
              <td mat-cell *matCellDef="let element"> {{element.usuario}} </td>
            </ng-container>
            <ng-container matColumnDef="c3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
              <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
            </ng-container>
            <ng-container matColumnDef="c4">
              <!--Check para seleccionar todo-->
              <th mat-header-cell *matHeaderCellDef>
                <div class="example-button-row">
                  <mat-checkbox class="example-margin" *ngIf="this.dataSource.data.length>0"
                    (change)="selectAllCheck($event.checked)"></mat-checkbox>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [(ngModel)]="element.status_reg" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                <span *ngIf="element.status_reg==true"></span>
              </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
            <h2></h2>
          </table>
          <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]"
            showFirstLastButtons></mat-paginator>
          <p></p>
        </div>


        <!--Fecha de asignación-->
        <div class="grid-container" *ngIf="tipoSoliSeleccionada('ALTA DE SERVICIOS'); ">
          <br>
          <mat-label class="label">Fecha de asignación<mat-label class="requerido">*</mat-label></mat-label>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="picker" formControlName="fecha_planeada" [min]="fechaMinima">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

          </mat-form-field>
        </div>
      </div>
      <P></P>
      <!--DATOS GNERALES DE LOS PRIVILEGIOS-->
      <div
        *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS') || tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS') ">
        <h2>DATOS GENERALES DE LOS PRIVILEGIOS</h2>
        <!--Cargo y sucursal/oficina-->
        <P></P>
        <div class="grid-container2" *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS')">
          <!--Cargo-->
          <div class="celda">
            <br>
            <mat-label class="label"> Cargo a cubrir<mat-label class="requerido">*</mat-label></mat-label>
            <mat-form-field appearance="outline">
              <mat-select placeholder="Seleccione el cargo que ocupara mientras ocupe los privilegios"
                formControlName="puesto_a_cubrir">
                <mat-option *ngFor="let puesto1 of listaCargos" [value]=puesto1>{{ puesto1.nombrePuesto }} </mat-option>
              </mat-select>
              <mat-error *ngIf="this.formSolicitud.get('puesto_a_cubrir')?.errors?.['required']">
                El cargo a cubrir es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <!--Oficina/Sucursal-->
          <div class="celda">
            <br>
            <mat-label class="label"> Sucursal a cubrir<mat-label class="requerido">*</mat-label></mat-label>
            <mat-form-field appearance="outline">
              <mat-select placeholder="Seleccione la sucursal en donde requiere los privilegios"
                formControlName="sucursal_a_cubrir">
                <mat-option *ngFor="let sucu of listaSucursales" [value]=sucu>{{ sucu.nombreSucursal }} </mat-option>
              </mat-select>
              <mat-error *ngIf="this.formSolicitud.get('sucursal_a_cubrir')?.errors?.['required']">
                La sucursal a cubrir es requerida
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="grid-container">
          <br>
          <mat-radio-group aria-label="Select an option" formControlName="tipo" class="grid-container2">
            <mat-radio-button value="Temporal">Temporal</mat-radio-button>
            <mat-radio-button value="Permanente">Permanente</mat-radio-button>
          </mat-radio-group>

        </div>
        <p></p>
        <p></p>
        <div class="grid-container" *ngIf="tipoSeleccionado('Temporal'); ">
          <br>
          <mat-label class="label"> Elija un rango de fechas<mat-label class="requerido">*</mat-label></mat-label>
          <mat-form-field appearance="fill">
            <mat-label> Fecha de alta - Fecha de baja </mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fecha_alta" placeholder="Start date" [min]="fechaMinima">
              <input matEndDate formControlName="fecha_baja" placeholder="End date" [min]="fechaMinima" required>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1></mat-date-range-picker>

            <mat-error *ngIf="range.controls.fecha_alta.hasError('matStartDateInvalid')">Invalid start date</mat-error>
            <mat-error *ngIf="range.controls.fecha_baja.hasError('matEndDateInvalid')">Invalid end date</mat-error>
            <mat-error *ngIf="this.range.get('fecha_baja')?.errors?.['required']">
              Es necesario que elija un rango de fechas
            </mat-error>
          </mat-form-field>

        </div>
        <div class="grid-container2">
        </div>
      </div>
      <br>
      <!--Comentarios-->
      <div class="grid-container">
        <div class="celda">
          <mat-label class="label"
            *ngIf=" tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS')==false; ">Comentarios<mat-label
              class="requerido">*</mat-label></mat-label>
          <mat-label class="label"
            *ngIf="tipoSeleccionado('Temporal')==false && tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS'); ">Motivo de
            la suspensión <mat-label class="requerido">*</mat-label> </mat-label>
          <mat-label class="label"
            *ngIf="tipoSeleccionado('Temporal') && tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS'); ">Motivo de la
            suspención temporal <mat-label class="requerido">*</mat-label> </mat-label>
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput placeholder="Comentarios" formControlName="comentarios" required></textarea>
            <mat-error *ngIf="this.formSolicitud.get('comentarios')?.errors?.['required']">
              Los comentarios son requeridos
            </mat-error>
          </mat-form-field>
        </div>
      </div>


    </div>
    <!--Botones-->
    <div class="grid-container2">
      <!--Boton guaradar-->
      <button type="submit" mat-raised-button color="primary" [disabled]="!habilitarBotonSolicitud()"
        (click)="enviarSolicitud()">Guardar<mat-icon>save</mat-icon></button>
      <!--Boton cancelar-->
      <button mat-raised-button color="warn" (click)="goBack()">Cancelar<mat-icon>cancel</mat-icon></button>

      <!--<button mat-raised-button color="primary" (click)="createSolicitudPrueba()" >Generar PDF<mat-icon></mat-icon></button>-->
    </div>
  </form>

</div>